import InterfaceConfig from '../../components/interfaceConfig/InterfaceConfig';
import WidgetConfig from '../../components/widgetConfig/WidgetConfig';

import { InterfaceConfigPaths } from './InterfaceConfigPaths';

export const interfaceConfigRoutes = [
  {
    path: InterfaceConfigPaths.INTERFACE_CONFIG,
    component: InterfaceConfig,
    exact: true
  },
  {
    path: InterfaceConfigPaths.WIDGET_CONFIG,
    component: WidgetConfig,
    exact: true
  }
];
